import { createDriverApi, deleteDriverApi, getAllDriverApi, getDriverDetailsApi, updateDriverApi } from "../../helpers/backend_helper";

import {
    getDriverList,
    driverByIdData,
    errorMessages,
    setLoading,
} from "./reducer";


export const getAllDriverList = (currentPage, pageSize, searchText) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "read", value: true }));
        const response = await getAllDriverApi(currentPage, pageSize, searchText);        
        dispatch(getDriverList(response));
    } catch (error) {
        dispatch(errorMessages(error.response.data.message));

    } finally {
        dispatch(setLoading({ type: "read", value: false }));
    }
};

export const createDriver = (data) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "create", value: true }));        
        await createDriverApi(data);
        return { success: true, message: "Driver Successfully Created" };
    } catch (error) {
        const errorMessage = error.response.data.errors;
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "create", value: false }));
    }
};


export const getDriverById = (id) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "getById", value: true }));
        let response;
        response = getDriverDetailsApi(id);
        const data = await response;        
        dispatch(driverByIdData(data));
    } catch (error) {
        const errorMessage = error.response.data.detail;
        dispatch(errorMessages(errorMessage));
    } finally {
        dispatch(setLoading({ type: "getById", value: false }));
    }
};


export const updateDriver = (id, data) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "update", value: true }));        
        await updateDriverApi(id, data);
        return { success: true, message: "Driver Successfully Updated" }
    } catch (error) {
        const errorMessage = error.response.data.errors;
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "update", value: false }));
    }
};


export const deleteDriver = (id) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "delete", value: true }));
        await deleteDriverApi(id);
        return { success: true, message: "Driver Successfully Deleted" };
    } catch (error) {
        const errorMessage = error.response.data.errors;
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "delete", value: false }));
    }
}